/* eslint-disable max-len */
export default {
  nameDefault: 'Padrão',
  active: 'Activar',
  disableNotifications: 'Ocultar notificación',
  activeNotifications: 'Mostrar notificación',
  active2: 'Activo',
  action: 'Acciones',
  addNewLimit: 'Agregar nuevo límite',
  admin: 'Admin',
  adminUsers: 'Usuarios administradores',
  adminUserRegister: 'Registro de usuario administrador',
  adminUserSuccess: '¡Nuevo usuario administrador creado con éxito!',
  adminUserSuccessUpdate: '¡El usuario administrador cambió con éxito!',
  addEstimateBuy: 'Procesar Compra',
  addEstimate: 'Agregar a la Cotización',
  address: 'Dirección',
  aboutUs: 'Acerca de Nosotros',
  app: 'APP',
  approve: 'Aprobar',
  approved: 'Aprobado',
  approved3: 'Aprobada',
  refused: 'Rechazado',
  approved1: 'Aprobador 1',
  approved2: 'Aprobador 2',
  approveError1: 'Aprobador 1 debe ser informado',
  authorized: 'Autorizado',
  bankSlip: 'Não há boleto no Chile',
  clientAutoBilling: '¿Facturación automática?',
  autoBillingError: '¿Facturación automática? no seleccionado',
  clientCustomerUnit: '¿Mostrar la unidad de medida del cliente?',
  customerUnitError: '¿Mostrar la unidad de medida del cliente? no seleccionado',
  projectsForIntegratorsError: '¿Proyectos para integradores? no seleccionado',
  allowSellSpotItensWithoutStock: '¿Permitir vender artículos SPOT sin stock?',
  allowSellSpotItensWithoutStockError: '¿Permitir vender artículos SPOT sin stock? no seleccionado',
  banners: 'Banners',
  banner: 'Banner',
  bannerCreated: 'Banner creado con éxito.',
  bannerUpdated: 'Banner actualizado con éxito.',
  bannerRegister: 'Registro de Banners',
  bannerImportText1: 'A coluna Nome (name) deve conter no máximo 255 caracteres.',
  bannerImportText2: 'A coluna Url para redirecionamento (redirectUrl) deve conter no máximo 255 caracteres.',
  bannerImportText3: 'A coluna Descrição (description) deve conter no máximo 255 caracteres.',
  manufacturers: 'Fabricantes',
  manufacturerCreated: 'Fabricante creado con éxito.',
  manufacturerUpdated: 'Fabricante actualizado con éxito.',
  manufacturerRegister: 'Registro de Fabricantes',
  manufacturerImportText11: 'A coluna Nome (name) deve conter no máximo 255 caracteres.',
  manufacturerImportText22: 'A coluna Url para redirecionamento (redirectUrl) deve conter no máximo 255 caracteres.',
  manufacturerImportText33: 'A coluna Descrição (description) deve conter no máximo 255 caracteres.',
  billing: 'Facturación',
  birthday: 'Fecha de nacimiento',
  brand: 'Marca',
  brandId: 'Marca id',
  buttonNotInserted: 'Nombre del botón no ingresado.',
  bu: 'BU',
  buNotSelected: 'BU no seleccionada.',
  business: 'Rama de Actividad',
  buyButton: 'Botón Comprar (Texto)',
  buyDate: 'Fecha de compra',
  cashDescount: 'Descuento en pesos',
  cancel: 'Cancelar',
  canceled: 'Cancelado',
  cancelOrder: 'Cancelar Pedido',
  category: 'Categoría',
  categoryId: 'Categoría id',
  categories: 'Categorías',
  categoryAssociated: 'Categoría ya asociada con la marca',
  categoryName: 'Ingrese el nombre de la categoría',
  categoryName2: 'Nombre de la categoría',
  categorySaved: 'Categoría guardada con éxito.',
  categoryUpdated: 'Categoría actualizada con éxito.',
  categoryFather: 'Categoría padre',
  categoryRoot: 'Categoría raiz',
  categoryAlreadyExists: '¡Error! No se puede crear una categoría que ya existe ',
  categoryParentNotFound: '¡Error! parentId de categoría no es válido. ',
  cantEditAdmin: 'No se puede editar este usuario',
  cart: 'Carrito',
  cartUser: 'Aprobar carritos (Nivel 2)',
  captured: 'Realizado',
  categoryDeleted: 'Categoría excluída con éxito.',
  categoryHasNotChild: 'Categoría tiene una categoría hija, no es posible excluirla.',
  categoryFatherExplanation: 'La categoría principal puede ser la identificación de una categoría existente o el nombre',
  cep: 'Código Postal',
  change: 'Cambio',
  cif: 'CIF',
  cnpj: 'RUT',
  cpf: 'RUN',
  city: 'Ciudad',
  cidRedispatch: 'CID_REDESPACHO',
  create: 'Crear',
  clientId: 'Cód. Cliente',
  client: 'Cliente',
  clients: 'Clientes',
  clientMinimumPurchase: 'Monto Mínimo de Compra (Carrito)',
  clientMinimumProduct: 'Monto Mínimo de Compra (Producto)',
  clientName: 'Nombre del cliente',
  clientNotSelected: 'Cliente no seleccionado.',
  clientCreated: 'Cliente creado con éxito.',
  clientRegister: 'Registro de cliente',
  clientWithdraw: 'Mostrar opción ¿Cliente retira?',
  clientImportText1: 'La columna (clientId) debe llenarse con el ID del cliente',
  clientImportText2: 'La columna (Apodo del cliente) debe llenarse con el apodo del cliente',
  clientImportText3: 'La columna (Tipo de flete) debe llenarse con el tipo de flete [ cif, fob, redespacho ]',
  clientImportText4: 'La columna (E-mails) debe ser llenado usando el separador "punto y coma" [ ; ]',
  clientImportText5: 'La columna (Sucursal) debe completarse con el código del establecimiento',
  clientImportText6: 'La columna (Bodega) debe ser llenada con el [(código de establecimiento)_(código de depósito)]',
  clientImportText7: 'La columna (Unidad de negocio (BU)) debe ser llenada con el código de la unidad de negocio',
  clientImportText8: 'La columna (Condición de pago) debe ser llenada con el código de condiciones de pago',
  clientImportText9: 'La columna (Políticas de precios) debe ser llenada con el código de la política de precios',
  clientImportText10: 'La columna (Exhibir descripción del cliente) debe completarse con 1 para SÍ o 0 para NO',
  clientImportText11: 'La columna (Mostrar opción (Cliente retira)) se debe llenar con 1 para SÍ o 0 para NO',
  clientImportText12: 'La columna (Mostrar la unidad de medida del cliente) debe llenarse con 1 para SÍ o 0 para NO',
  clientImportText29: 'La columna (Proyectos para integradores) debe llenarse con 1 para SÍ o 0 para NO',
  clientImportText13: 'La columna (Mostrar producto del contrato sin precio) debe completarse con 1 para SÍ o 0 para NO',
  clientImportText14: 'La columna (Permitir vender artículos SPOT sin stock) debe llenarse con 1 para SÍ o 0 para NO',
  clientImportText15: 'La columna (XML) debe completarse con 1 para SÍ o 0 para NO',
  clientImportText16: 'La columna (CSV) debe completarse con 1 para SÍ o 0 para NO',
  clientImportText17: 'La columna (PDF) debe ser llenada con 1 para SÍ o 0 para NO',
  clientImportText18: 'La columna (JSON) debe completarse con 1 para SÍ o 0 para NO',
  clientImportText19: 'La columna (Botón Comprar (Texto)) debe ser rellenada con el texto del botón para tramitar la compra en la e-shop [ default = "Procesar Compra" ]',
  clientImportText20: 'La columna (Facturación automática) debe completarse con 1 para SÍ o 0 para NO',
  clientImportText21: 'La columna (Monto Mínimo de Compra (Carrito)) debe llenarse solo con números y usar el punto [ . ]. Si no se informa un número válido, el sistema se establecerá por default en 0',
  clientImportText22: 'La columna (Monto Mínimo de Compra (Producto)) debe llenarse solo con números y usar el punto [ . ]. Si no se proporciona un número válido, el sistema se establecerá por default en 0',
  clientImportText23: 'La columna (Código de regla PunchOut) debe ser llenada con el código de la regla PUNCHOUT',
  clientImportText24: 'La columna (PunchOut ID) debe ser llenada con el ID del PUNCHOUT',
  clientImportText25: 'La columna (Código de Proveedor de Punchout) debe ser llenada con el código PUNCHOUT forcedor',
  clientImportText26: 'La columna (Número de Contrato de Punchout) debe ser llenada con el número de contrato PUNCHOUT',
  clientImportText27: 'La columna (Permitir Catálogo de Punchout) debe completarse con 1 para SÍ o 0 para NO',
  clientImportText28: 'La columna (Nombre del Catálogo de Punchout) debe ser llenada con el nombre del catálogo PUNCHOUT',
  company: 'Compañia',
  code: 'Código',
  confirm: 'Confirmar',
  confirmPassword: 'Confirmar contraseña',
  confirmClient: '¿Desea realmente confirmar el cliente?',
  contactId: 'ID del Contato',
  contract: 'Convenios',
  contractId: 'ID del Contrato',
  contractNotSelected: 'Convenio no seleccionado',
  contractNumberNotSetted: 'Número de convenio no configurado',
  consuption: 'Uso_consumo',
  complement: 'Complemento',
  country: 'Pais',
  conveyor: 'Transportador:',
  credit: 'Crédito',
  creditLimit: 'Limite de crédito',
  created: 'Creado con éxito',
  createdIn: 'Creado en',
  changedIn: 'Última modificación',
  dateHour: 'Fecha/ horario de la compra',
  dateTime: 'Fecha/Hora',
  dateInit: 'Fecha de Inicio de la Promoción',
  dateFinal: 'Fecha Final de la Promoción',
  initDate: 'Fecha Inicial',
  finDate: 'Fecha Final',
  dateLess: 'Fecha de la promoción es menor que la fecha actual.',
  dateMajor: 'Fecha inicial es mayor o igual que la fecha final de la promoción.',
  delete: 'Eliminar',
  deleteSpotlightModal: '¿Desea realmente eliminar el producto destacado?',
  deleteCategoryModal: '¿Desea realmente eliminar la categoría?',
  deleteProductModal: '¿Desea realmente desactivar el producto?',
  deletePromotionModal: '¿Desea realmente eliminar la promoción?',
  deletePromotion: '¿Realmente desea eliminar promociones?',
  delivered: 'Entregado',
  deliveryLocation: 'Lugar de entrega',
  deleteLimit: 'Excluir',
  deposit: 'Bodega',
  depositNotSelected: 'Bodega no seleccionada.',
  mainDeposit: 'Bodega Principal',
  mainDepositNotSelected: 'Bodega Principal no seleccionada.',
  details: 'Ver detalles',
  debit: 'Débito',
  description: 'Descripción',
  descriptionRequire: 'Descripción es obligatoria',
  descriptionImageRequire: 'Descripción de la imagen es obligatoria.',
  descount: 'Descuento',
  dragAndDrop: 'Clique aquí para seleccionar los archivos.',
  dragAndDropBannerErrorTitle: 'Banners no añadidos:',
  dragAndDropBannerErrorDescription: 'La descripción debe ser informada',
  dragAndDropManufacturerErrorTitle: 'Fabricantes no añadidos:',
  dragAndDropManufacturerErrorDescription: 'La descripción debe ser informada',
  dragAndDropClientErrorNickname: 'Campo nickname no válido',
  dragAndDropClientErrorFreight: 'Campo freight no válido',
  dragAndDropClientErrorPaymentTerm: 'Campo paymentTerms no válido',
  dragAndDropClientErrorBu: 'Campo bu no válido',
  dragAndDropClientErrorLocation: 'Campo locationId no válido',
  dragAndDropClientErrorPricePolicy: 'Campo pricePolicy no válido',
  dragAndDropClientErrorDeposit: 'Campo deposit no válido',
  dragAndDropClientErrorJSONInvalid: 'Campo fileEmailJson no válido',
  dragAndDropClientErrorXMLInvalid: 'Campo fileEmailXML no válido',
  dragAndDropClientErrorCSVInvalid: 'Campo fileEmailCsv no válido',
  dragAndDropClientErrorPDFInvalid: 'Campo fileEmailPdf no válido',
  dragAndDropClientErrorDisplayClientDescription: 'Campo displayClientDescription no válido',
  dragAndDropClientErrorShowContractProductWithoutPrice: 'Campo showContractProductWithoutPrice no válido',
  dragAndDropClientErrorClientWithdraw: 'Campo clientWithdraw no válido',
  dragAndDropClientErrorAllowSellSpotItensWithoutStock: 'Campo allowSellSpotItensWithoutStock no válido',
  dragAndDropClientErrorProjectsForIntegrators: 'Campo no válido (Proyectos para integradores)',
  dragAndDropClientErrorAutoBilling: 'Campo autoBilling no válido',
  dragAndDropClientErrorCustomerUnit: 'Campo customerUnit no válido',
  dragAndDropClientErrorProductCatalogPunchout: 'Campo productCatalogPunchout no válido',
  dragAndDropClientErrorClientPunchoutRule: 'Campo punchoutRule no válido',
  dragAndDropClientErrorClientCheckbuyExist: 'Cliente ya existe en el Checkbuy',
  dragAndDropClientErrorClientSphereDontExist: 'Cliente no está registrado en el Sphere',
  dragAndDropClientErrorTitle: 'Clientes no agregados:',
  dragAndDropClientErrorUserNotRegisteredSphere: 'Usuario no registrado Sphere',
  dragAndDropClientErrorUserNotActiveSphere: 'Usuario no activado en Sphere',
  dragAndDropFeaturedErrorTitle: 'Fabricantes destacados no agregados:',
  dragAndDropFeaturedErrorCategory: 'Categoría no encontrada',
  dragAndDropFeaturedErrorBrand: 'Marca no encontrada',
  dragAndDropFeaturedErrorExist: 'La relación Marca / Categoría ya existe.',
  dragAndDropProductErrorTitle: 'Productos no adictos:',
  dragAndDropProductErrorSphere: 'Sphere id no encontrado',
  dragAndDropProductErrorCategory: 'Categoría no encontrado',
  dragAndDropPromotionErrorTitle: 'Promociones no agregadas:',
  dragAndDropPromotionErrorType: 'El tipo debe ser "value" o "percentage".',
  dragAndDropPromotionErrorStartedAt: 'La fecha de inicio debe estar en el formato DD/MM/AA HH:MM.',
  dragAndDropPromotionErrorFinalizedAt: 'La fecha de finalización debe estar en el formato DD/MM/AA HH:MM.',
  dragAndDropPromotionErrorProductId: 'Producto no encontrado',
  dragAndDropPromotionErrorSubstituted: 'Promociones cambiadas',
  dragAndDropPromotionErrorNotReplaced: 'Esta promoción cambia varias otras promociones',
  dragAndDropUserErrorTitle: 'Usuarios no agregados:',
  dragAndDropUserErrorAccessCart: 'Si cartPermission está configurado en "N", no se puede liberar ningún método de pago',
  dragAndDropUserErrorApproveCart: 'Si cartUserPermission tiene un valor "S", se debe liberar alguna forma de pago',
  dragAndDropUserErrorVisualizeCart: 'Si cartUsersPermission está configurado en "S", cartPermission debe estar configurado en "S"',
  dragAndDropUserErrorVisualizePrice: 'Si pricePermission se establece en "N", no se puede liberar ningún método de pago',
  dragAndDropUserErrorUserNotRegisteredSphere: 'Usuario no registrado Sphere',
  dragAndDropUserErrorUserNotActiveSphere: 'Usuario no activado en Sphere',
  dragBanner: 'Clique aquí para seleccionar el imagen de banner.',
  dragManufacturer: 'Clique aquí para seleccionar el imagen de fabricante.',
  dragCategory: 'Clique aquí para seleccionar el imagen de categoría.',
  disable: 'Desactivar',
  district: 'Barrio',
  edit: 'Modificar',
  email: 'Correo electrónico',
  emails: 'E-mails',
  emailNotAdded: 'E-mails no agregados.',
  emailNotRegistered: 'E-mail no registrado en Sphere',
  end: 'Fin',
  errorOcurred: 'Ocurrio un error, intente más tarde.',
  estimate: 'Cotización',
  exit: 'Salir',
  noData: 'Sin datos',
  noDataPeriod: 'No hay datos para este período',
  failed: 'Fallado',
  failedTotvs: 'Se produjo un error durante la integración con Totvs. Para reenviar la integración, haga clic en el botón de acciones (Reenviar integración).',
  failedSphere: 'Se produjo un error durante la integración con Sphere. Para reenviar la integración, haga clic en el botón de acciones (Reenviar integración).',
  freight: 'Flete',
  freightType: 'Tipo de flete',
  freightTypeObs: 'Esta condición de flete será aplicada cuando el cliente seleccione Entrega Normal',
  export: 'Exportar',
  ExportSixtyDays: 'Exportar últimos 60 días',
  freightNotSelected: 'Flete no seleccionado.',
  finalizePurchase: 'Finalizar compra',
  finalizePurchaseCredit: 'Finalizar compra con tarjeta de crédito',
  finalizePurchaseDebit: 'Finalizar compra con tarjeta de débito',
  finalizePurchaseBankSlip: 'No há boleto no Chile',
  finalizePurchaseBilling: 'Finalizar compra con facturación',
  fob: 'FOB',
  fullName: 'Nombre completo',
  generateCSV: 'Generar archivo CSV',
  generateEstimate: 'Generar cotización',
  golNotSelected: 'Finalidad no seleccionada.',
  icmsDiferido: 'Diferido de ICMS',
  icmsIsento: 'Exento de ICMS',
  init: 'Inicio',
  info: 'Info',
  inactive: 'Inactivo',
  industrialization: 'Industralización',
  invalidCsvFile: 'Archivo inválido, verifique si el archivo está en CSV con el formato correcto.',
  insertFirstName: 'Ingrese el nombre de usuario',
  insertDescount: 'Ingrese el descuento',
  integrated: 'Integrado',
  inTransport: 'En transporte',
  invoice: 'Facturas emitidas',
  invoiceDone: 'Facturación Emitida',
  invoiceNumber: 'Número de factura',
  invoiceText: 'Factura ',
  invoicePartially: 'Parcialmente facturado',
  invalidImageFormat: 'Imagen inválida, utilize jpeg, jpg, gif o png.',
  import: 'Importar',
  importClient: 'Importar cliente',
  importClientUser: 'Importar usuario',
  importClientUsers: 'Importar usuarios de clientes',
  importUser: 'Importar Usuarios',
  importProducts: 'Importar Productos',
  importCategories: 'Categorías / subcategorías de importación',
  importModel: 'Modelo para importación',
  invalidEmail: 'El e-mail que ingresó no tiene un formato válido',
  importBanners: 'Importar Banners',
  importManufacturers: 'Importar Fabricantes',
  importClients: 'Importar Clientes',
  importFeaturedManufactures: 'Importar Fabricantes Destacados',
  importPromotions: 'Importar Promociones',
  importText1: 'Para que la importación funcione es necesario que:',
  importText2: 'La primera línea debe contener el título de la columna.',
  importText3: 'El archivo debe estar en formato CSV.',
  importText4: 'Todos los campos son obligatorios.',
  importText5: 'La primera línea debe contener el título de la columna todo diminuto y sin acentos.',
  ipi: 'IPI',
  item: 'Ítem',
  lastAcess: 'Ultimo acceso',
  lastName: 'Apellido',
  layouts: 'Layouts',
  line: 'Línea',
  lines: 'Líneas',
  limitError: 'Los límites no pueden ser iguales',
  loginText: 'Panel de administración del Checkbuy',
  limitTo: 'limitar a',
  limitText: '(Autorizado) Límites de finalización de pedidos',
  manufacturerImportText1: 'A coluna Marca (brand) deve conter no máximo 255 caracteres e deve estar cadastrada no TECTAG.',
  manufacturerImportText2: 'A coluna Categoria (category) deve conter no máximo 11 digitos.',
  monetarySymbolPrefix: '$ ',
  noLimit: 'No seleccionar límite',
  name: 'Nombre',
  nameImageRequire: 'Nombre de la imagen obligatorio.',
  naoContribIcms: 'ICMS no Contribuyente',
  newUsers: 'Nuevos usuarios',
  newRegisterUpdate: 'Nuevo registro actualizado con éxito',
  newRegisterUpdateError: 'Nuevo registro con error de actualización',
  nickname: 'Apodo',
  no: 'No',
  notDefined: 'No definido',
  notAuthorized: 'No autorizado',
  notFinalized: 'No finalizado',
  notification: 'Notificaciones de APP',
  notificationRegistration: 'Notificación de Registro',
  noInvoices: 'Sin NF\'s',
  number: 'Numero',
  opcoHeaderMessage: 'Mensaje del site institucional',
  opcoUrlSite: 'Url del site institucional',
  paid: 'Pagado',
  panel: 'Panel',
  pageNotFound: '¡Página no encontrada!',
  password: 'Contraseña',
  passwordDifferents: 'Las contraseñas son diferentes',
  passwordText: 'Las contraseñas deben ser mayor que seis y menor que cincuenta caracteres.',
  noPassword: 'Las contraseñas son un campo obligatorio',
  params: 'Parámetros',
  payment: 'Pago',
  paymentType: 'Forma de Pago',
  paymentStatus: 'Estado de Pago',
  paymentCondition: 'Condición de Pago',
  paymentConditionNotSelected: 'Condición de pago no seleccionada.',
  paymentDone: 'Pago confirmado',
  pendingOrdersCSV: 'Pendiente de Aprobación',
  permissionErrorText1: 'Al menos un método de pago debe estar activo si se selecciona Aprobar carrito',
  permissionErrorText2: 'Ver precio del producto debe estar activo si se selecciona Aprobar carrito.',
  permissionErrorText3: 'No puede seleccionar: Pagar con tarjeta de crédito, Pagar con tarjeta de débito si Mostrar precios del producto no está seleccionado.',
  permissionErrorText4: 'No puede seleccionar: Pagar con tarjeta de crédito, Pagar con tarjeta de débito, Pagar con factura de compra y Pagar con facturación si el acceso al carrito no está habilitado',
  permissionLabel1: 'Obligatorio Ver precio de producto activo',
  permissionLabel2: 'Se requiere acceso activo al carrito',
  permissionLabel3: 'Se requiere acceso al carrito y al menos algún método de pago activo',
  percentage: 'Porcentaje',
  percentagemDescount: 'Descuento en porcentaje',
  phone: 'Teléfono',
  pisCofins: 'PIS/COFINS',
  place: 'Sucursal',
  places: 'Sucursales',
  mainPlace: 'Sucursal Principal',
  mainPlaceNotSelected: 'Sucursal Principal no seleccionada.',
  placeNotSelected: 'Sucursal no seleccionada.',
  placeRegister: 'Registro de Sucursal',
  placeDelete: 'De verdad quieres eliminar este Sucursal?',
  placeCreated: 'Establecimiento creado con éxito',
  placeUpdated: 'Sucursal cambiado con éxito',
  stateRequire: 'El campo de estado es obligatorio.',
  placeRequire: 'El campo de sucursal es obligatorio.',
  branch: 'Subsidiaria',
  price: 'Precio',
  proEmprego: 'Pró-Emprego (Somente SC)',
  productCode: 'Código del Producto',
  product: 'Producto',
  products: 'Productos',
  productAdded: 'Producto agregado con éxito',
  productImportText1: 'Es obligatorio completar los campos: Sphere (cód producto Sphere), categoría (Id. De categoría) y SPOT.',
  productImportText2: 'El campo Sphere corresponde al código del producto. Esto debe estar registrado en TECTAG y no debe ser un producto obsoleto.',
  productImportText3: 'El campo Categoría (category) debe insertarse con el número correspondiente a la ID de categoría.',
  productImportText4: 'El campo Descripción (description) debe contener un máximo de 100 caracteres. Si este campo está vacío, se cargará la descripción de TECTAG.',
  productImportText5: 'El campo SPOT debe completarse como S, si desea que el elemento se muestre en SPOT y la columna debe estar con N si desea que el elemento no se muestre en SPOT.',
  productImportText6: 'Si el campo Marca (brand) está vacío, se cargará la marca registrada en TECTAG.',
  productImportText7: 'El campo Destaque debe completarse como S, si desea que el elemento se muestre en Destaque y la columna debe estar con N si desea que el elemento no se muestre en Destaque.',
  productImportText8: 'El campo SPOT debe completarse como S, si desea que el elemento se muestre en OFERTA y la columna debe estar con N si desea que el elemento no se muestre en OFERTA.',
  productRegister: 'Registro de productos',
  productUpdated: 'Producto actualizado con éxito.',
  productDeleted: 'Producto eliminado con éxito.',
  productBought: 'Producto(s) comprado(s)',
  promotions: 'Promociones',
  promotionCreated: 'Promociones creadas con éxito.',
  promotionUpdated: 'Promoción actualizada con éxito.',
  promotionRegister: 'Registro de promociones',
  promotionType: 'Tipo de promoción',
  promotionImportText1: 'A coluna Produto (productId) corresponde ao código no TECTAG e deve conter no máximo 20 caracteres.',
  promotionImportText2: 'A coluna Tipo de Promoção (type) deve conter os valores value ou percentage.',
  promotionImportText3: 'A coluna Aparecer relógio para cronometrar? (showTimer) deve conter o valor 0 para NÃO ou 1 para SIM.',
  promotionImportText4: 'A coluna Data do Inicio da Promoção (startedAt) deve estar no formato DD/MM/AA HH:MM:SS. Ex. "01/01/20 08:00:00"',
  promotionImportText5: 'A coluna Data Final da Promoção (finalizedAt) deve estar no formato DD/MM/AA HH:MM:SS. Ex. "15/01/20 18:00:00"',
  promotionImportText6: 'A coluna Valor (value) deve conter no maximo 10 digitos e 2 casas decimais. Ex. "20.00"',
  processed: 'Procesado',
  providerReturn: 'Código Retorno',
  mainProvider: 'Proveedor Principal',
  policy: 'Política',
  policyNotSelected: 'Política no seleccionada.',
  popupBody: 'Mensaje para POP-UP en la pantalla de inicio',
  punchoutRule: 'Regla PunchOut',
  punchoutRules: 'Reglas PunchOut',
  punchoutN1Rules: 'Regras PunchOut Nível 1',
  punchoutN2Rules: 'Regras PunchOut Nível 2',
  punchOutRuleCreated: 'Regla PunchOut creada con éxito',
  punchOutRuleUpdated: 'Regla PunchOut actualizada con éxito',
  punchOutRuleRegister: 'Registro de Reglas PunchOut',
  punchoutRuleError: 'Toda la información debe ser completada',
  purpose: 'Finalidad',
  redirectUrl: 'Url de redireccionamiento',
  register: 'Registrar',
  registerDate: 'Fecha de registro',
  registerSolicitation: 'Solicitud de registro',
  registerMonitor: 'Monitor de registro',
  registerUpdated: 'Última Actualización',
  requestDate: 'Fecha de solicitud',
  return: 'Volver',
  returnHome: 'Volver para Inicio',
  resale: 'Reventa',
  resendIntegration: 'Reenviar integración',
  role: 'Función',
  screenHome: 'Pantalla de Inicio',
  screenProduct: 'Pantalla de Producto',
  screenCart: 'Pantalla de Carro de la compra',
  save: 'Guardar',
  toSend: 'Enviar',
  saveOrder: 'Orden',
  saved: 'Guardado con éxito',
  search: 'Buscar',
  sector: 'Sector',
  send: 'Enviar',
  settings: 'Configuraciones',
  selectContact: 'Seleccione el contacto.',
  selectContract: 'Seleccione el contrato.',
  selectDateInit: 'Seleccione la fecha de inicio de la promoción.',
  selectDateFinal: 'Seleccione la fecha final de la promoción.',
  selectProduct: 'Seleccione el producto.',
  selectCategory: 'Seleccione la categoría.',
  selectBrand: 'Seleccione la marca.',
  selectDescount: 'Seleccione el tipo de descuento.',
  selectDescription: 'Seleccione la descripción del producto.',
  selectImage: 'Seleccione la imagen.',
  selectEmail: 'Seleccionar un correo electrónico',
  selectPromotionType: 'Seleccione el tipo de promoción.',
  separateBySemicolon: "Separados por punto y coma ';'",
  spot: 'Spot',
  spotlight: 'Destaque',
  spotlightManufacturer: 'Fabricantes Destacados',
  spotlightManufacturerRegister: 'Registro de fabricantes destacados',
  solicitationUser: 'Usuário Solicitante',
  status: 'Estado',
  visibility: 'Visibilidad',
  stopWatch: 'Cronómetro',
  state: 'Región',
  stateRegistration: 'Inscripción Estadual',
  signIn: 'Entrar',
  showDescription: '¿Exhibir descripción del cliente no seleccionado?',
  showContractProductWithoutPriceError: 'Mostrar producto del contrato sin precio no seleccionado',
  showClientDescription: '¿Exhibir descripción del cliente?',
  showContractProductWithoutPrice: 'Mostrar producto del contrato sin precio?',
  showTime: 'Seleccione si el cronómetro será exhibido.',
  showTime2: '¿Aparecer reloj para cronometrar?',
  sphereId: 'Cód. Sphere',
  showing: 'Mostrando',
  shoppingCartPermission: 'Permisos de carrito de compras',
  socialMedia: 'Redes sociales',
  successActualized: 'Actualizado con éxito.',
  successFile: 'Archivo enviado con éxito.',
  tectagProductNotFound: 'El producto no está registrado con TecTag, comuníquese con el soporte.',
  tectagProductBrandNotFound: 'El registro del producto TecTag no contiene marca, comuníquese con el soporte.',
  type: 'Tipo',
  titleExibition: 'Título de Exhibición',
  total: 'Total',
  orders: 'Pedidos',
  orderDone: 'Pedido realizado',
  orderDelivered: 'Pedido entregado',
  orderDetails: 'Detalles del pedido',
  ok: 'OK',
  quantity: 'Cantidad:',
  userBlocked: 'Usuario está bloqueado.',
  userNotFound: 'Usuario no encontrado.',
  userInvalidPassword: 'Contraseña invalida.',
  userInvalid: 'Usuario o contraseña inválida.',
  update: 'Actualizar',
  resend: 'Reenviar',
  user: 'Usuario',
  users: 'Usuarios',
  userCreated: 'Usuario creado con éxito',
  userRegister: 'Registro de usuario',
  userForm: 'Formulário de usuario',
  undefined: 'Indefinido',
  urlToRedirect: 'Url para redireccionamiento',
  urlToRedirectInternal: 'Url para redireccionamiento Interno',
  urlToRedirectExternal: 'Url para redireccionamiento Externo',
  uploadUserText1: 'Para que la importación funcione es necesario que:',
  uploadUserText2: 'La primera línea debe contener el título de la columna.',
  uploadUserText3: 'El archivo debe estar en formato CSV.',
  uploadUserText4: 'Todos los campos son obligatorios.',
  uploadUserText5: "En la columna 'role' considere '1' para 'admin' y '0' para 'usuario'.",
  uploadUserText6: "En las columnas de permisos (Permission) considere el valor 'S' para sí y 'N' para no.",
  uploadUserText7: 'Campos de Ids como máximo 10 números',
  uploadUserText8: 'Todos los campos no mencionados deben contener como máximo 255 caracteres.',
  uploadUserText9: 'Referencia de campos :',
  uploadUserText10: '(E-mail del usuario),',
  uploadUserText11: '(Id del cliente),',
  uploadUserText12: '(Id del contractos separados por -),',
  uploadUserText13: '(Nombre del usuario),',
  uploadUserText14: '(Contraseña del usuario),',
  uploadUserText15: '(Rol de admin/usuario),',
  uploadUserText16: '(Permiso para visualizar carrito),',
  uploadUserText17: '(Permiso para visualizar carritos de otros usuarios),',
  uploadUserText18: '(Permiso para efectuar una compra),',
  uploadUserText19: '(Permiso para efectuar pago con tarjeta de crédito),',
  uploadUserText20: '(Permiso para efectuar pago con tarjeta de débito),',
  uploadUserText21: 'Não há boleto no Chile',
  uploadUserText22: '(Permiso para facturar),',
  uploadUserText23: '(Permiso para hacer cotizaciones),',
  uploadUserText24: '(Permiso para produtos alternativos),',
  uploadUserText25: '(Permiso de panel),',
  uploadUserText26: '(Permiso de stock),',
  uploadUserText27: '(Permiso de plazo de entrega),',
  uploadUserText28: '(Permiso de cross selling),',
  uploadUserText29: '(Permiso de ver precio),',
  uploadUserText30: '(Permiso de código del cliente),',
  uploadUserText31: '(Permiso para pedido ir para sphere),',
  uploadUserText32: '(Permiso para reciber e-mail),',
  uploadUserText33: '(Permiso para visualizar producto spot),',
  uploadUserText34: '(Permiso para visualizar código Opco),',
  uploadUserText35: '(Permiso para visualizar código Sonepar),',
  uploadUserText36: '(Permiso para visualizar todos los carritos).',
  value: 'Valor',
  valueMajor: 'El valor debe ser mayor o igual a 0.1',
  valueManjorLess: 'El valor debe ser mayor que 0 y menor que 100',
  visualization: 'Visualización',
  visualizeCart: 'Visualizar carrito de compras',
  visualizeSimilarity: 'Visualizar productos alternativos',
  visualizePanel: 'Visualizar panel',
  visualizeStock: 'Visualizar stock',
  visualizeLeadtime: 'Visualizar lead-time',
  visualizeCrossselling: 'Visualizar productos cross-selling',
  visualizePrice: 'Visualizar precio de los productos',
  visualizeClientCode: 'Agregar orden de compra en el carrito',
  visualizeSpot: 'Visualizar productos Spot',
  visualizeOrder: 'Ver pedido',
  visualizeOpicCode: 'Ver código ',
  visualizeSoneparCode: 'Ver código Sonepar',
  visualizeInvoices: 'Ver Doctos',
  visualizeAllOrders: 'Ver todos los pedidos',
  yes: 'Sí',
  waiting: 'Esperando',
  waitingSphere: 'Solicitación esperando aprobación de Sphere',
  branchTectag: 'Marca Tectag',
  updateBrandTectag: '¿Cambiar la marca Tectag?',
  descriptionTectag: 'Descripción comercio electrónico Tectag',
  updateDescriptionTectag: '¿Cambiar la descripción de Tectag?',
  recommendedImportText1: 'Es obligatorio completar los campos: Sphere (cód producto Sphere), categoría (Id. De categoría) y SPOT.',
  recommendedImportText2: 'El campo Categoría (category) debe insertarse con el número correspondiente a la ID de categoría.',
  importRecommendeds: 'Importación de recomendaciones de productos',
  dragAndDropRecommendedErrorProductCode: 'Producto no agregado o no válido',
  dragAndDropRecommendedErrorCategoryId: 'Categoría no agregada o no válida',
  dragAndDropRecommendedErrorId: 'Ya existe un registro para el producto informado',
  dragAndDropRecommendedErrorTitle: 'Recomendaciones de productos no agregadas',
  recommendeds: 'Recomendaciones Productos',
  recommendedRegister: 'Registro de recomendaciones',
  recommendedCreated: 'Recomendación creado con éxito.',
  recommendedUpdated: 'Recomendación actualizado con éxito.',
  deleteRecommendedModal: '¿Desea realmente eliminar la recomendación de producto?',
  accessProfileUpdated: 'Se cambió el perfil de acceso',
  accessProfileCreated: 'Perfil de acceso creado',
  profile: 'Perfil',
  accessProfiles: 'Perfiles de acceso',
  accessProfileRegister: 'Registro de perfil de acceso',
  admMenus: 'Menús administrativos',
  admMenuRegister: 'Registro del menú administrativo',
  admMenuCreated: 'Menú creado',
  admMenuUpdated: 'Menú cambiado',
  parentMenu: 'Menú relacionado ',
  level: 'Nivel',
  title: 'Título',
  relevance: 'Relevancia',
  pathCode: 'Código Camino',
  permissions: 'Permisos',
  checkAll: 'Marcar Todos',
  uncheckAll: 'Desmarcar Todos',
  showMenu: 'Mostrar en el menú',
  wrongLevel: 'Nivel inválido',
  levelRequire: 'Nivel requerido',
  parentMenuRequire: 'Menú relacionado requerido',
  noAccessPermissionCode: 'Sin permiso de acceso. Código de programa:',
  newItemVendor: 'Código de Proveedor de Punchout',
  newItemContract: 'Número de Contrato de Punchout',
  allowPunchoutCatalog: 'Permitir Catálogo de Punchout',
  catalogName: 'Nombre del Catálogo de Punchout',
  catalogNameError: 'Se debe informar el nombre del catálogo',
  saoPauloCustomersEstablishment: 'Clientes del Estado de São Paulo:',
  establishmentCustomersOutsideSaoPaulo: 'Clientes fuera del estado de São Paulo:',
  accessLogin: 'Login de Acceso',
  initialDate: 'Fecha de Inicio',
  finalDate: 'Fecha Final',
  generateReport: 'Generar Reporte',
  noOptions: 'Sin opciones',
  categoryShopBottomMenu: 'Categorías de menú horizontal',
  awaitPayment: 'Aguardando Pagamento',
  offer: 'Oferta',
  supportUrlSite: 'Url Soporte',
  popupBodyButtonLabel: 'Mensaje botón POP-UP en la pantalla de inicio',
  popupBodyURL: 'Url botón POP-UP en la pantalla de inicio',
  exportProducts: 'Precios de Exportación',
  EnterCode: 'Ingrese el código del emisor',
  EnterType: 'Ingrese el tipo de producto',
  customerProducts: 'precios-cliente.csv',
  warning: 'Advertencia',
  disabledPromotions: 'Promociones para discapacitados',
  existingPromotion: 'Ya existe una promoción activa para este producto, ¿quieres modificarla?',
  deleteSelected: 'Eliminar seleccionado',
  approverWithPendingCart: 'Permiso denegado, los aprobadores tienen carritos pendientes! ',
  limitContract: 'límite por contrato',
  withoutChange: 'No se aplica',
  limitBlockedContract: 'Botón de bloqueo',
  limitContractNotice: 'Mensaje de advertencia',
  orderingBanners: 'Pedido de pancartas',
  selectBanner: 'seleccione el banner',
  bannersCurrentlyActive: 'No hay banner activos actualmente',
  mobile: 'Mobile',
  environment: 'Ambiente',
  clienteWithoutActivity: 'Cliente sin rubro informado. No está permitido activar el cliente.',
  deactivatedClient: 'cliente desactivado',
  customerDisabledNotice: 'No se puede activar el usuario y el cliente para ser activado',
  discountCoupon: 'Cupón de Descuento',
  couponCode: 'Código Promocional',
  couponDescription: 'Descripción del Cupón',
  startDate: 'Fecha de Inicio',
  endDate: 'Fecha Final',
  couponRegistration: 'Registro de Cupón',
  minimumValue: 'Valor Mínimo',
  couponType: 'Tipo de Cupón',
  couponStartDate: 'Fecha de inicio del cupón',
  couponEndDate: 'Fecha de finalización del cupón',
  amountOfUse: 'Límite de Cupón',
  timesUsed: 'N° de veces usado',
  historic: 'Histórico',
  clean: 'Limpiar',
  allCustomers: 'Todos los Clientes',
  allSelectedCustomer: 'Todos los clientes seleccionados',
  erro: 'Error',
  erroFetch: 'Error o recuperar los datos',
  couponDisabled: 'cupom desativado',
  noticeToEditCoupon: 'El cupón no se puede editar si está deshabilitado',
  changeMade: 'Cambio realizado con éxito',
  registrationPerformed: 'Registro exitoso',
  discount: 'Descuento',
  discountCouponHistory: 'Historial de Cupones de Descuento',
  orderCode: 'Código de Orden',
  activeOrder: 'Orden Activa',
  orderCanceled: 'Orden Cancelada',
  dateOfUse: 'Fecha de Uso',
  importDiscountCoupons: 'Importar Cupones de Descuento',
  couponsNotAdded: 'Cupones No Agregados',
  couponsNotAddedNotFound: 'ingrese este campo',
  couponsNotAddedCharactersNotAllowed: 'Caracteres No Permitidos',
  couponsNotAddedAlreadyUsed: 'ya usado en otro cupón',
  couponsNotAddedErrorFindingCustomer: 'error al encontrar cliente',
  couponsNotAddedErrorFindingBrands: 'error al encontrar proveedor',
  couponsNotAddedOnlyAcceptsNumbers: 'Solo se aceptan números',
  couponsNotAddedOnlyIntegersAreAccepted: 'Solo se aceptan números enteros',
  couponsNotAddedInvalidFormat: 'Formato inválido',
  couponsNotAddedMinorDate: 'Menos que la fecha actual',
  couponsNotAddedMinorEndDate: 'Debe ser posterior a la fecha de inicio',
  couponsNotAddedAndAccepted: 'Solo acepto 0 o 1',
  couponsNotAddedBiggerNumbers: 'Solo se acepta valor mayor a 0',
  couponsNotAddedPercentageLimit: 'Solo se aceptan 2 caracteres en el porcentaje',
  successfulImportMessage: 'Fue posible importar %{0} líneas del archivo',
  mandatory: 'Obligatorio',
  importCouponsText1: '(couponCode) se debe informar el código del cupón, que contiene solo números, letras, _',
  importCouponsText2: '(description) deve ser informado a descrição do cupom',
  importCouponsText3: '(client) debe informarse únicamente los códigos de cliente separados por una coma o * para representar a todos los clientes',
  importCouponsText11: '(brands) debe informarse únicamente los códigos de proveedor separados por una coma o * para representar a todos los proveedor',
  importCouponsText4: '(amountOfUse) número de veces que diferentes clientes pueden usar el cupón',
  importCouponsText5: '(initialDate) se debe informar la fecha de inicio del cupón en el formato DD/MM/YYYY hh:mm',
  importCouponsText6: '(finalDate) se debe informar la fecha final del cupón en el formato DD/MM/YYYY hh:mm',
  importCouponsText7: '(minimumValue) Y se puede utilizar el valor mínimo que debe tener el pedido para el cupón',
  importCouponsText8: '(type) el tipo de cupón, 0 valor, 1 porcentaje',
  importCouponsText9: '(valor) y el valor que tendrá el cupón',
  importCouponsText10: '(estado) Y el estado del cupón, 0 Activo, 1 Desactivado',
  segment: 'Sector',
  customerUserNotAdded: 'Usuario del cliente no agregado',
  informThisField: 'Ingrese este campo',
  customerNotRegistered: 'Cliente no registrado',
  userNotRegisteredSphere: 'Usuario no registrado sphere',
  userNotActiveSphere: 'Usuario no activado en Sphere',
  userAlreadyRegistered: 'Usuario ya registrado',
  duplicateLine: 'Línea duplicada',
  contractNotFound: 'Contrato no encontrado',
  valueNotAllowedForThisField: 'Valor no permitido para este campo',
  notCorrespondWithRegisteredData: 'El valor no se corresponde con los datos registrados',
  cannotHaveApprover: 'Parámetro (cartUsersPermission) activo no puede tener probador',
  cannotHaveApprovingPaymentTerms: 'Parámetro (purchaseCreditPermission, purchaseDebitPermission, purchaseBankSlipPermission, purchaseBillingPermission) activo no puede tener probador',
  couponsNotAddedTheMinimumValue: 'El valor mínimo debe ser mayor que 1',
  uninformed: '(approveId1) no informado',
  unregisteredUser: 'Usuario no registrado',
  userNotAllowed: 'Usuario no autorizado para ser aprobado',
  importClientUsers1: '(clientId) Se debe proporcionar el código de cliente',
  importClientUsers2: '(email) Se debe proporcionar el correo electrónico del usuario',
  importClientUsers3: '(password) Se debe proporcionar la contraseña del usuario',
  importClientUsers4: '(%{0}) de (%{1}), Ingresa solo el código separado por ,',
  importClientUsers5: '(%{0}) de (%{1}), S para sí N para no',
  importClientUsers6: '(%{0}) de (%{1}), Ingresa solo el código',
  importClientUsers7: '(%{0}) de (%{1}), Informar e-mail del aprobador',
  importClientUsers8: '(%{0}) de (%{1}), Informar el valor',
  filterOrderType: 'Filtrar solicitudes',
  filterOrderType1: 'Todas las solicitudes',
  filterOrderType2: 'Solo tradicional',
  filterOrderType3: 'Solo PunchOut',
  ToFinish: 'Por Finalizar',
  toConfirm: 'Por confirmar',
  pending: 'Pendiente',
  solicitationCompleted: 'Solicitud completada',
  forceCompletion: 'Forzar finalización',
  deleteCoupon: 'eliminar cupón',
  deleteNotify: 'eliminar Notificación',
  canNotBeUndone: 'Esta acción no se puede deshacer',
  greenPortfolio: 'Portafolio Verde',
  position: 'posición',
  cancelThisRequest: '¿Quieres cancelar esta solicitud?',
  productFeedbackReason: 'Motivo de la valoración del producto',
  idReason: 'Razón de identificación',
  reason: 'Razón',
  registerProductFeedbackReason: 'Registrar Razón de la valoración del producto',
  editProductFeedbackReason: 'Editar el motivo de la valoración del producto',
  disabledRecord: 'registro deshabilitado',
  noticeToProductFeedbackReason: '(Razón de comentarios sobre el producto) no se puede editar si está deshabilitado',
  companyLogo: 'Logotipo del cliente',
  chooseFile: 'Elegir archivo',
  logoCurrentlyActive: 'Ningún archivo seleccionado',
  fileError: 'Error al enviar el archivo del logotipo del cliente',
  errorAttachingFile: 'Error al adjuntar el archivo',
  InvalidFileExtension: 'La extensión de archivo no es válida',
  clientOrderType: 'Tipo de cumplimiento de pedidos',
  TotalBilling: 'Facturación total',
  ParcialBilling: 'Facturación parcial',
  orderTypeError: 'Tipo de cumplimiento de pedidos no seleccionado',
  brands: 'proveedor',
  allBrandsSelected: 'Todas los proveedor seleccionadas',
  allBrands: 'Todas los proveedor',
  estimateConvertedToOrder: 'cotización que pasó a pedido',
  close: 'Cerrar',
  visualize: 'Visualizar',
  purchaseFeedback: 'Comentarios de compra',
  userFeedbackTitle: 'Comentarios de los usuarios:',
  userFeedbackScore: 'Nota de comentarios:',
  feedbackDetails: 'Detalles de los comentarios de compra',
  filter: 'Filtrar',
  dateFieldsNotReported: 'los campos de fecha no fueron informados',
  fieldsNotReported: 'Los campos no fueron informados',
  startDateAndGreater: 'La fecha de inicio es posterior a la fecha de finalización',
  punchoutUserIdentification: 'Identificación usuario PunchOut',
  selectRequiredParameters: 'Seleccione qué parámetros son obligatorios',
  enableParameters: 'Habilitar parámetros',
  projectsForIntegrators: 'Proyectos para integradores',
  technicalMaterial: 'Material Técnico',
  coursesAndTraining: 'Cursos y capacitaciones',
  courseName: 'Nombre del curso',
  certificate: 'Certificado',
  date: 'Fecha',
  Hour: 'Hora',
  opportunities: 'Oportunidades',
  efkCode: 'Codigo EFK',
  projectName: 'Nombre Proyecto',
  director: 'Mandante',
  segment2: 'Segmento',
  stage: 'Etapa',
  projectsDirectory: 'Directorio de Proyectos',
  importCoursesAndTraining: 'Importar Cursos y Capacitaciones',
  notImported: 'No importado',
  notFound: 'ingrese este campo',
  invalidFormat: 'Formato inválido',
  importTechnicalMaterial: 'Importar Material Técnico',
  importProjectsDirectory: 'Importar Directorio de Proyectos',
  id: 'ID',
  projectsDirectoryText1: 'La columna (codigo efk) debe ser llenado solo con números',
  projectsDirectoryText2: 'La columna (inversion usdmm) debe ser llenado solo con números',
  UpdateTechnicalMaterial: 'Actualizar Material Técnico',
  numberOfStudents: 'Cantidad de Alumnos',
  instructors: 'Instructores',
  UpdateCoursesAndTraining: 'Actualizar Cursos y capacitaciones',
  usdmmInvestment: 'Inversión usdmm',
  region: 'Región',
  objective: 'Objetivo',
  location: 'Ubicación',
  descriptionOfWorksAndActivities: 'Descripción de obras y actividades',
  usefulLife: 'Vida útil',
  mainTeams: 'Equipos principales',
  investment: 'Inversión',
  timeline: 'Cronograma',
  statusAtSea: 'Estado en sea',
  others: 'Otros',
  UpdateProjectsDirectory: 'Actualizar Directorio de Proyectos',
  managerEmail: 'Rellene la dirección de correo electrónico del gestor',
  finalizePurchasePaymentGateway: 'Getnet',
  getnetTypeOPayment: 'Getnet (Tarjeta de crédito, débito o prepago)',
  partial: 'Parcial',
  dateApproved1: 'Fecha primer aprobador',
  dateApproved2: 'Fecha según aprobador',
  minBillingDate: 'Fecha mínima de facturación',
  code2: 'Código:',
  soneparCode: 'Código Sonepar:',
  clientCode: 'Código del Cliente:',
  typeBanner: 'Tipo de banner',
  applicantsName: 'Nombre y apelido',
  email2: 'Correo electrónico',
  province: 'Comuna',
  message: 'Mensaje',
  requestType: 'Sección de la solicitud',
  referenceId: 'Id de referencia',
  nameReference: 'Nombre de referencia',
  contact: 'contacto',
  feedbackMedianRating: 'Nivel medio de satisfacción',
  bannersMain: 'Banners Principal',
  integratorContactList: 'Listado de contactos integradores',
  clientSolicitationType: '¿El solicitante define la dirección de entrega?',
  identifyInternalDeliveryLocation: '¿El solicitante identifica el lugar de entrega interno?',
  erpCode: 'Código ERP',
  initialDateNotFound: 'Fecha de inicio no encontrada',
  invalidInitialDate: 'Fecha inicial inválida',
  finalDateNotFound: 'Fecha de finalización no encontrada',
  invalidFinalDate: 'Fecha final inválida',
  dateGreaterThanToday: 'La fecha de inicio y de finalización no puede ser mayor que la fecha de hoy',
  initialDateGreaterThanFinalDate: 'La fecha de inicio no puede ser mayor que la fecha de finalización',
  unknownError: 'Error desconocido, por favor, inténtelo más tarde',
  unmappedError: 'Error no mapeado, por favor inténtelo más tarde',
  reportGeneratedSuccessfully: 'Informe generado con éxito',
  dataNotFound: 'No se han encontrado datos',
  errorCategory: 'Error al activar/desactivar la categoría',
  successCategory: 'Categoría "%{0}" desactivada con éxito, con un total de %{1} productos desactivados.',
  showCategoryName: 'Categoría %{0} activada correctamente',
  changeStatus: 'Cambiar estado',
  changeCategoryStatusModal: 'Tenga en cuenta que al desactivar la categoría "%{0}" también se desactivarán los productos y subcategorías relacionados. ¿Le gustaría continuar de todos modos?',
  categoryNotActivated: 'Categoría no activada',
  categoryNotFound: 'Categoría no encontrada',
  buttonName: 'Nombre del botón',
  productNotFound: 'Producto no encontrado',
  notificationHistory: 'Historial de Notificaciones',
  hide: 'Esconder',
  viewMore: 'Ver más...',
  sendDate: 'Fecha y hora del envío',
  previewDate: 'Fecha y hora de visualización',
  filterProducts: 'Filtrar productos',
  web: 'Sitio',
  webMobile: 'Sitio Mobile',
  displayOn: 'Mostrar en',
  bell: 'Campaña',
  viewPercentage: 'Open Rate',
  notificationEmail: 'Correo electrónico de notificación',
  notificationEmailRegistration: 'Registro de correo electrónico de notificación',
  getnetPayment: 'Pago Getnet',
  reCaptchaValidationFailed: 'La verificación reCAPTCHA falló',
  typeSolution: 'Tipo de Solución',
  typeSolutionRegistration: 'Registro de Tipo de Solución',
  deleteTypeSolution: '¿Quiere eliminar el tipo de solución?',
  cableCategory: 'Categoría de Cable',
  cableCategoryRegistration: 'Registro de Categoría de Cable',
  categoryRegistration: 'Registro de Categoría',
  typeCoating: 'Tipo de Chaqueta',
  typeCoatingRegistration: 'Registro de Tipo de Chaqueta',
  productTelecomRegistration: 'Registro de Productos',
  supplierTelecomRegistration: 'Registro de Proveedores',
  formula: 'Fórmula',
  result: 'Resultado',
  fixedValue: 'Valor Fijo',
  meters: 'Metros',
  points: 'Puntos',
  operators: 'Operadores',
  errorFormula: 'Error en la fórmula...',
  sum: 'Agregar',
  reduce: 'Disminuir',
  multiply: 'Multiplicar',
  divide: 'Dividir',
  openParentheses: 'Abrir Paréntesis',
  closeParentheses: 'Cerrar Paréntesis',
  removeTheLast: 'Quitar el Ultimo',
  removeAll: 'Eliminar Todo',
  emptyFormula: '¡No puedes dejar la fórmula vacía!',
  purchaseReport: 'Reporte de Pedidos',
  analytics: 'Tráfico del sitio',
  analyticsLive: 'En vivo',
  analyticsHistory: 'Histórico',
  analyticsActiveUsers: 'Usuarios activos',
  analyticsSessions: 'Sesiones',
  analyticsPurchaseRevenue: 'Ingresos por compras',
  analyticsTopPages: 'Páginas principales',
  analyticsPagePath: 'Página',
  analyticsPageViews: 'Vistas',
  analyticsFunnel: 'Embudo',
  analyticsFunnelAddToCart: 'Agregar al carrito',
  analyticsFunnelBeginCheckout: 'Iniciar checkout',
  analyticsFunnelPurchase: 'Compra',
  analyticsTimeseries: 'Serie temporal',
  analyticsDate: 'Fecha',
  analyticsValue: 'Valor',
  analyticsUpdatedAt: 'Actualizado en',
  analyticsEmpty: 'Sin datos sincronizados para el período',
  analyticsEmptyLive: 'Sin datos en vivo por el momento',
  analyticsSeeLiveForNow: 'Para datos de ahora, use la pestaña En vivo',
  analyticsLakeOff: 'Exportación lake desactivada',
  analyticsLakePending: 'Pendientes en lake: %{count}',
  analyticsSourceDirect: 'Consulta directa GA4',
  analyticsDbSync: 'Último sync BD',
  analyticsCached: 'Caché',
  analyticsLoading: 'Cargando…',
  analyticsRefresh: 'Actualizar',
  analyticsStale: 'Sincronización retrasada — verifique el job',
  analyticsCount: 'Cantidad',
  analyticsOverview: 'Resumen',
  analyticsChartsTitle: 'Gráficos del período',
  analyticsKpiCommerce: 'Comercio',
  analyticsKpiCommercial: 'Resumen comercial',
  analyticsKpiEngagement: 'Compromiso y cuenta',
  analyticsOverviewFunnel: 'Embudo del período',
  analyticsTabTraffic: 'Tráfico',
  analyticsTabFunnel: 'Embudo',
  analyticsTabProduct: 'Producto',
  analyticsTabAuth: 'Auth',
  analyticsTabRefund: 'Reembolso',
  analyticsViewItem: 'Visualización de producto',
  analyticsLogin: 'Inicio de sesión',
  analyticsSignUp: 'Registro',
  analyticsRefunds: 'Reembolsos',
  analyticsRefundRevenue: 'Ingresos por reembolsos',
  analyticsMethod: 'Método',
  analyticsItem: 'Producto',
  analyticsTopItems: 'Productos principales',
  analyticsAuthMethods: 'Métodos de autenticación',
  analyticsAddToCart: 'Agregar al carrito',
  analyticsBeginCheckout: 'Iniciar checkout',
  analyticsPurchases: 'Compras',
  analyticsReports: 'Informes',
  analyticsReportsNew: 'Nuevo informe',
  analyticsTabEngagement: 'Compromiso',
  analyticsSolicitudNuevosUsuarios: 'Solicitud nuevos usuarios',
  analyticsCantidadCotizaciones: 'Cantidad de cotizaciones',
  analyticsMontoCotizaciones: 'Monto cotizaciones',
  analyticsGenerateEstimate: 'Cotizaciones generadas',
  analyticsRegistrationRequest: 'Solicitudes de registro',
  analyticsGenerateLead: 'Leads generados',
  analyticsAddToWishlist: 'Lista de deseos',
  analyticsSearch: 'Búsquedas',
  analyticsContactClick: 'Contacto',
  analyticsRemoveFromCart: 'Quitar del carrito',
  analyticsAddShippingInfo: 'Envío informado',
  analyticsAddPaymentInfo: 'Pago informado',
  analyticsJourney: 'Recorrido del cliente',
  analyticsJourneyIntro: 'Revise paso a paso lo que hizo cada cliente en la tienda: inicio de sesión, productos vistos, carrito, checkout y compra. Los eventos provienen del sitio (con cookies aceptadas) — distinto del Histórico, que muestra totales agregados de GA4.',
  analyticsJourneySearch: 'Encontrar cliente',
  analyticsJourneySearchHint: 'Ingrese al menos 2 caracteres del nombre, correo o empresa. Luego haga clic en un resultado para ver la línea de tiempo de los últimos 7 días.',
  analyticsJourneySearchPlaceholder: 'Ej.: maria@empresa.cl o nombre del cliente…',
  analyticsJourneySelectHint: 'Busque un cliente arriba para ver su recorrido.',
  analyticsJourneyNoResults: 'Ningún cliente encontrado para esta búsqueda.',
  analyticsJourneyNoResultsHint: 'Revise la ortografía o pruebe otro término (correo parcial, nombre o razón social).',
  analyticsJourneyEmpty: 'No hay eventos registrados para este cliente en los últimos 7 días.',
  analyticsJourneyEmptyHint: 'Puede que la persona no haya navegado con sesión iniciada, haya rechazado cookies o aún no tenga acciones rastreadas en este entorno.',
  analyticsJourneyTimeline: 'Línea de tiempo',
  analyticsJourneyTimelineSubtitle: 'Eventos en orden cronológico (últimos 7 días, huso horario Chile).',
  analyticsJourneyLastAction: 'Última acción',
  analyticsJourneyResultsTitle: 'Clientes encontrados — haga clic para ver el recorrido',
  analyticsJourneyPage: 'Página',
  analyticsSearchTerm: 'Término',
  analyticsTransactionId: 'Pedido',
  analyticsLeadType: 'Tipo de lead',
  analyticsAdvancedShow: 'Informes personalizados (avanzado)',
  analyticsAdvancedHide: 'Ocultar informes personalizados',
  analyticsReportsEdit: 'Editar informe',
  analyticsReportsName: 'Nombre',
  analyticsReportsMetrics: 'Indicadores',
  analyticsReportsBreakdown: 'Detalle',
  analyticsReportsBreakdownNone: 'Ninguno',
  analyticsReportsBreakdownTopPages: 'Top páginas',
  analyticsReportsBreakdownTopItems: 'Top productos',
  analyticsReportsBreakdownAuth: 'Auth por método',
  analyticsReportsDefaultRange: 'Período predeterminado',
  analyticsReportsSave: 'Guardar',
  analyticsReportsCancel: 'Cancelar',
  analyticsReportsDeleteConfirm: '¿Eliminar este informe?',
  analyticsReportsEmptyList: 'Ningún informe guardado',
  analyticsReportsRunEmpty: 'Sin datos sincronizados para el período',
  analyticsReportsOpen: 'Abrir',
  analyticsReportsNameRequired: 'Ingrese el nombre del informe',
  analyticsReportsMetricsRequired: 'Seleccione al menos un indicador',
  analyticsReportsRangeDays: '%{count} días',
  analyticsHomeCta: 'Ver Analytics',
  analyticsHomeTitle: 'Resumen',
  supplier: 'Proveedor',
  resendPassword: 'Reenviar Contraseña',
  resendPasswordNotice: 'Se generará una nueva contraseña y se enviará directamente al correo electrónico del usuario.',
  resendPasswordSuccess: 'Se ha enviado el email con la nueva contraseña.',
  editar: 'Editar',
  new: 'Nuevo',
  applicationType: 'Tipo Aplicación',
  voltage: 'Voltage',
  start: 'Início',
  voltageRange: 'Voltage Range',
  powerRange: 'Rango de Potencia',
  powerRangeStart: 'kW Inicial',
  powerRangeEnd: 'kW Final',
  kw: 'kW',
  hp: 'HP',
  power: 'Potencia',
  importAutomationProductsText1: '(productCode) Se debe informar el código del produto.',
  importAutomationProductsText2: '(applicationType) Se debe informar el tipo de aplicación.',
  importAutomationProductsText3: '(voltageRange) Se debe informar el rango de voltage.',
  importAutomationProductsText4: '(power) Se debe informar la potencia.',
  importAutomationProductsText5: '(status) Se debe informar el estado del producto.  0 - Activo , 1 - Inactivo.',
  automationProductsNotFound: 'ingresa a este campo',
  automationProductsRecordNotFound: 'Registro no encontrado',
  automationProductsAndAccepted: 'Solo acepto 0 o 1',
  automationProductsDuplicateRecord: 'Registro duplicado',
  productsNotAdded: 'productos no agregados',
  sphereUpdateContactError: 'Error al actualizar estado de contacto en Sphere',
  statusContact: 'Estado de contacto',
  buRequire: 'El campo de BU es obligatorio.',
  general: 'General',
  userLoggedOutSeesStock: '¿Mostrar el stock para usuarios no logueados?',
  userLoggedInSeesStock: '¿Mostrar el stock para usuarios logueados?',
  errorUpdatingGeneralParams: '¡Error al actualizar los parámetros generales!',
  propertyCredential: 'Credencial de la Propiedad',
  companyOrDependent: 'Empresa / Profesional Dependiente',
  personalDocument: 'RUT Personal',
  completeRegister: 'Continuar el registro',
  noClient: 'Cliente no registrado en el Panel de Administración.',
  confirmContactClient: '¿Realmente desea registrar el contacto?',
  documentCompany: 'Documento de la empresa (RUT)',
  clientErrorContactNotRegisteredSphere: 'Registro de Contacto en Sphere',
  clientErrorNotRegisteredCheckbuy: 'Registro de Cliente en Checkbuy',
  userErrorNotRegisteredCheckbuy: 'Registro de Usuario en Checkbuy',
  contactInCheckbuy: 'Contacto registrado en Checkbuy',
  toolTipPayments: '¡La condición de pago se recibe automáticamente de Sphere!',
  ekam: 'Emails EKAM',
  sellersEmails: 'Correos electrónicos de vendedores',
  allSolicitations: 'Todas las solicitudes',
  pendingSphere: 'Pendientes en Sphere',
  pendingCheckbuy: 'Pendientes en Checkbuy',
  placeAlreadyRegistered: 'La sucursal ya está registrada.',
  downloadImage: 'Descargar la imagen',
  deliveryLocationError: '¡La sucursal elegida por el usuario no está registrada en Sphere/Panel Admin Checkbuy! Por favor, regístrela primero antes de completar el registro de usuario.',
  emailSeller: 'Correo electrónico del vendedor',
  preferencesBranch: 'Sucursal de Atención del Cliente',
  abandonedCart: 'Carrito abandonado',
  cartTracking: 'Seguimiento de Carrito',
  pendingCartDays: 'Días de carrito pendiente',
  pendingQuotationDays: 'Días de cotización pendiente',
  customerNotBuyingForDays: 'Días de visitantes sin compras',
  sendEmailAbandoned: 'Enviar correo electrónico de carrito o cotización abandonada',
  typeEmail: 'Tipo de correo electrónico',
  codeQuotation: 'Código de cotización',
  userWithQuotation: 'Usuario con cotización',
  userWithoutPurchase: 'Usuario sin compra',
  emailSended: 'Correo electrónico enviado',
  emailSentDate: 'Fecha envío email',
  sendEmail: 'Enviar correo electrónico',
  selectNewImage: 'Seleccione una nueva imagen',
  confirmChangeImage: 'Guardar',
  maximumValue: 'Valor Máximo',
  manager: 'Gestor',
  redemptionAmount: 'Cantidad de Redencion',
  labelSelectTypeEmail: 'Seleccione el tipo de correo',
  dateHourLogin: 'Fecha / Hora de Acceso',
  categorySustainable: 'Categoría Sostenible',
  couponDiscountForNewUser: 'Cupón de Descuento para Usuarios Nuevos',
  couponDueDaysForNewUser: 'Días hasta el vencimiento del cupón para nuevo usuario',
  discountPercentageForNewUserCoupon: 'Porcentaje de descuento del cupón para nuevo usuario',
  minimumValueForNewUserCoupon: 'Valor mínimo para usar el cupón para nuevo usuario',
  maximumValueForNewUserCoupon: 'Monto máximo aplicable del cupón para nuevo usuario',
  dateInicialToGenerateCoupon: 'Día de inicio para generar el cupón (número del día del mes)',
  dateFinalToGenerateCoupon: 'Día final para generar el cupón (número del día del mes)',
  toolTipDatesToGenerateCoupon: 'Ingrese solo el número del día del mes. Por ejemplo: del día 15 al 30',
  configuracionCorreosAutomaticos: 'Configuración de Correos Electrónicos Automáticos',
  leadTime: 'Plazo de Entrega',
  cd: 'Centro Distribución',
  distributionCenterCode: 'Código del CD (Centro Distribución)',
  storeBranchCode: 'Código de la Sucursal',
  transferLeadTimeDays: 'Tiempo de Translado (Lead Time en días)',
  updatedLeadTime: 'Plazo de entrega actualizado con éxito',
  leadTimeAlreadyRegistered: 'El plazo de entrega ya está registrado para este centro de distribución y sucursal.',
  leadTimeCreated: 'Plazo de entrega creado con éxito',
  leadTimeRegister: 'Registro de Plazo de Entrega',
  deleteLeadTime: 'Eliminar Plazo de Entrega',
  allowMixedPurchase: 'Permitir Compra Mixta (con y sin stock)',
  labelAllowMixedPurchase: '¿Permitir que el cliente compre productos con y sin stock en el mismo pedido?',
  lastAccess: 'Último Acceso',
  situation: 'Situación',
  overdueClients: 'Clientes Morosos',
  searchOnlyByClientName: 'Buscar solo por nombre de cliente',
  financialEmails: 'Correos electrónicos financieros',
  financialSettings: 'Configuraciones financieras',
  notAllowedRegisterGuestUser: 'No está permitido registrar usuarios que realicen compras como invitados.',
  emailManager: 'Correo electrónico del gestor',
  branchManager: 'Gestión de Sucursales',
  branchManagerCreated: 'Sucursal creada con éxito',
  branchManagerUpdated: 'Sucursal actualizada con éxito',
  selectStoreBranch: 'Seleccione el código de sucursal',
  selectBranchName: 'Seleccione el nombre de sucursal',
  selectEmailManager: 'Ingrese el correo electrónico del gestor',
  emailTooLong: 'El correo electrónico es demasiado largo (máximo 254 caracteres)',
  onlyOneEmailAllowed: 'Solo se permite un correo electrónico por gestor',
  emailAlreadyRegistered: 'El correo electrónico ya está registrado para esta sucursal',
  branchManagerAlreadyExists: 'La sucursal ya está registrada para este gestor',
  branchManagerNotFound: 'Gestor de sucursal no encontrado',
  confirmDeleteBranchManager: '¿Desea eliminar el gestor de sucursal?',
  dateEffective: 'Fecha de vigencia',
  dateExpiration: 'Fecha de validez',
  sales: 'Ventas',
  selectStatus: 'Seleccione el estado',
  packsRegistration: 'Registro de Packs',
  packImage: 'Imagen del Pack',
  packDetails: 'Detalles del Pack',
  unitPrice: 'Precio Unit.',
  subtotal: 'Subtotal',
  remove: 'Eliminar',
  searchProduct: 'Buscar producto...',
  productAlreadyAdded: 'Producto ya agregado',
  selectedProducts: 'Productos seleccionados',
  pricingMethod: 'Forma de Valorización del Pack',
  fixedPriceLabel: 'Precio Fijo',
  discountPercentageLabel: 'Porcentaje de Descuento',
  finalPackValue: 'Valor Final del Pack',
  percentDiscountLabel: '% de Descuento',
  originalPrice: 'Precio Original',
  newPrice: 'Nuevo Precio',
  totalOriginal: 'Total Original del Pack',
  totalCurrent: 'Total Actual del Pack',
  pricingRequired: 'Defina la forma de valorización antes de añadir productos',
  invalidDiscountPercent: 'El porcentaje debe estar entre 1 y 100',
  packExpired: 'Pack vencido, no puede ser habilitado',
  visualizeAllStatus: 'Visualizar todos los estados',
  packStatus: 'Estado del Pack',
  pricingMethodShort: 'Valorización',
  itemsPerPage: 'Ítems por página',
  importsPacks: 'Importar Packs',
  importPacksText1: 'Para que la importación funcione es necesario que:',
  importPacksText2: 'El archivo puede estar en formato CSV o XLSX (Excel), con el mismo diseño de columnas.',
  importPacksText3: 'Los datos del pack van en las columnas A-E (Nombre, Fecha de Inicio, Fecha de Fin, Tipo de Precificacion, Valor), la columna F queda en blanco, y la tabla de ítems va al lado en las columnas G-I (Código, Cantidad, Precio Unitario). El ítem 1 va en la misma línea que los datos del pack; los demás ítems continúan hacia abajo solo en las columnas G-I.',
  importPacksText13: 'Se puede importar más de un pack en el mismo archivo: basta con repetir el bloque completo (línea de título y línea(s) de datos) tantas veces como packs se quiera crear. Una línea con "----------" o "==========" entre un pack y otro es opcional, pero ayuda a identificar visualmente dónde termina un pack y empieza el siguiente.',
  importPacksText4: 'Es obligatorio completar los campos: Nombre, Fecha de Inicio, Fecha de Fin, Tipo de Precificacion, Valor',
  importPacksText5: 'El campo Nombre hay que ser unico, es decir, no se puede crear a un pack nombrado de la misma manera que otro ya registrado, ni repetir el mismo nombre dos veces dentro del mismo archivo',
  importPacksText6: 'El campo Tipo Precificacion debe ser Fijo o Porcentual (y si es Porcentual, el Valor debe estar entre 0 y 100)',
  importPacksText10: 'Los campos Fecha de Inicio y Fecha de Fin deben ser informados en el formato DD/MM/YYYY',
  importPacksText7: 'El campo Valor debe recibir el valor correspondiente a el tipo. Si es Fijo, vá a ser el precio final; Si Porcentual, el porcentaje que se aplica a cada articulo, por su precio original',
  importPacksText8: 'El campo Código hay que contener el codigo de un articulo que esté obrigatoriamente registrado em CheckBuy, sin repetirse dentro del mismo pack',
  importPacksText9: 'El campo Cantidad debe contener la cantidad de dicho articulo en el pack',
  importPacksText11: 'El campo Precio Unitario es opcional y permite especificar el precio de cada producto en el pack. Si no se informa, el sistema utilizará el precio de la base de datos.',
  importPacksText12: 'La importación es todo o nada: si cualquier pack del archivo tiene un error, ningún pack del archivo se crea. Todos los errores encontrados se muestran juntos, para que pueda corregirlos de una vez.',
  packsNotAdded: 'Packs no agregados',
  packNotFound: 'Pack no encontrado',
  packCreated: 'Pack creado con éxito',
  packUpdated: 'Pack actualizado con éxito',
  deletePack: '¿Desea eliminar el pack?',
  importPacks: 'Importar Packs',
  importPacksError_PackNameRequired: 'El nombre del pack es obligatorio.',
  importPacksError_PackNameAlreadyExists: 'Ya existe un registro de pack con este nombre igual. No se puede importar. Cambie el nombre y inténtelo de nuevo.',
  importPacksError_DateEffectiveFormat: 'La fecha de inicio (Fecha de Inicio) debe ser informada en el formato DD/MM/YYYY.',
  importPacksError_DateExpirationFormat: 'La fecha final (Fecha de Fin) debe ser informada en el formato DD/MM/YYYY.',
  importPacksError_DateExpirationBeforeEffective: 'La fecha final no puede ser anterior a la fecha de inicio. Ajuste y vuelva a intentarlo.',
  importPacksError_PriceInvalid: 'El valor del pack, ya sea fijo o porcentual, no puede ser cero o nulo. No se puede importar. Ajuste y vuelva a intentarlo.',
  importPacksError_ProductNotRegistered: 'El producto con el código %{code} no está registrado en Checkbuy. No es posible continuar. ¡Corrija y vuelva a intentarlo!',
  importPacksError_QuantityInvalid: 'La cantidad del producto que se va a incluir en el Pack no puede ser nula o cero. Imposible continuar. Ajuste y vuelva a intentarlo.',
  importPacksError_FileFormat: 'El archivo no tiene el formato esperado (título del pack, datos del pack, título de los ítems y los ítems). Verifique la plantilla e inténtelo de nuevo.',
  importPacksError_PackHeaderMismatch: 'No se encontró la línea de título del pack ("Nombre;Fecha de Inicio;Fecha de Fin;Tipo de Precificacion;Valor") al inicio del archivo o de un bloque de pack. Descargue la plantilla y verifique el diseño.',
  importPacksError_ItemsHeaderMismatch: 'No se encontró la línea de título de los ítems ("Código;Cantidad;Precio Unitario") en la posición esperada. Descargue la plantilla y verifique el diseño.',
  importPacksError_NoItems: 'El pack debe tener al menos un ítem (producto).',
  importPacksError_PriceTypeInvalid: 'El campo Tipo de Precificacion debe ser exactamente "Fijo" o "Porcentual".',
  importPacksError_PercentageOutOfRange: 'Cuando el Tipo de Precificacion es Porcentual, el Valor debe estar entre 0 y 100.',
  importPacksError_ProductCodeRequired: 'El código del producto (Código) es obligatorio en todos los ítems del pack.',
  importPacksError_DuplicateProductCode: 'El producto con el código %{code} aparece más de una vez en el mismo pack. Elimine las líneas repetidas e inténtelo de nuevo.',
  importPacksError_UnitPriceInvalid: 'El Precio Unitario informado no es válido. Debe ser un número mayor o igual a cero, o dejarse en blanco.',
  importPacksError_DuplicatePackNameInFile: 'Este nombre de pack aparece más de una vez en el mismo archivo. Cada pack del archivo debe tener un nombre único.',
  importPacksError_ValidationFailed: 'Se encontraron los siguientes errores. Ningún pack fue importado — corrija todos los puntos y vuelva a intentarlo:',
  importPacksError_PricingUnavailable: 'No fue posible obtener el precio de este producto en este momento (servicio de precios no disponible). El pack no fue importado — vuelva a intentarlo más tarde, o informe manualmente el Precio Unitario de todos los ítems de este pack.',
  importPacksResultsImportedTitle: 'Packs importados con éxito:',
  importPacksResultsSkippedTitle: 'Packs no importados:',
};
